import React from "react";
import { Route } from "react-router-dom";
import InterimRedirect from "../components/InterimRedirect";
import DigitalAdvice from "../pages/DigitalAdvice";
import DigitalAdviceProcessPage from "../pages/DigitalAdviceProcessPage";
import NoRecommendations from "../pages/NoRecommendations";
import OurAdvice from "../pages/OurAdvice";
import DigitalAdviceProvider from "../providers/DigitalAdviceProvider";

interface IDigitalAdviceRoutes {
    base: string;
}

const DigitalAdviceRoutes: React.FC<IDigitalAdviceRoutes> = ({ base }) => {
    return (
        <DigitalAdviceProvider>
            <Route exact path={base}>
                <DigitalAdvice />
            </Route>
            <Route exact path={`${base}/:id/question`}>
                <DigitalAdviceProcessPage />
            </Route>
            <Route exact path={`${base}/our-advice`}>
                <OurAdvice />
            </Route>
            <Route exact path={`${base}/interim-cover`}>
                <InterimRedirect />
            </Route>
            <Route exact path={`${base}/no-recommendations`}>
                <NoRecommendations />
            </Route>
        </DigitalAdviceProvider>
    );
};

export default DigitalAdviceRoutes;
